import React from "react";
import LogoDto from "./media/logo_dto.svg";
import LogoPcc from "./media/logo_pcc.svg";

import "./index.css";

class FooterAyuda extends React.Component {
  render() {
    return (
      <React.Fragment>
        <footer className="footer__container--vw">
          <div className="container container__footer--ayuda">
            <div className={"footer__texto--" + this.props.marca}>
              {
                <div className="row">
                  <div className="col-md-7 col-10 offset-1 offset-md-0">
                    <div className="text-center marca__copyright">
                      &#169; Volkswagen de México 2021
                    </div>
                  </div>
                  <div className="text-right pt-1 col-md-2 col-3 offset-2 offset-md-0">
                    <img src={LogoDto} alt="dto" />
                  </div>
                  <div className="marca__border"></div>
                  <div className="text-left col-md-2 col-5 pt-2 pb-2">
                    <img className="w-100" src={LogoPcc} alt="commercial customer" />
                  </div>
                </div>
              }
            </div>
          </div>
        </footer>
      </React.Fragment>
    );
  }
}

export default FooterAyuda;
